<template>
  <div class="component-wrapper d-flex flex-column align-center breadcrumb">
    <Breadcrumb
      class="breadcrumb mb-8 mt-8"
      :breadcrumbItems="breadCrumbItems"
    />

    <v-row class="breadcrumb flex-grow-0">
      <v-col cols="6" sm="4">
        <v-select
          v-model="year"
          :items="years"
          value=""
          @change="getPeriods"
          label="Έτος"
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="6" sm="4">
        <v-select
          v-model="period"
          :items="periods"
          item-text="reportPeriodName"
          item-value="reportPeriodId"
          label="Περίοδος"
          clearable
          :loading="periodsLoader"
          :disabled="periodsLoader"
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="6" sm="4">
        <v-select
          v-model="creditInstitute"
          :items="creditInstitutes"
          value=""
          label="ΑΕΔΑΚ"
          clearable
          item-text="mmfManagerNationalName"
          item-value="creditInstituteId"
          return-object
          @change="fund = null"
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="6" sm="4">
        <v-select
          v-model="fund"
          :items="funds"
          value=""
          label="Κεφάλαια"
          clearable
          item-text="mmfNationalName"
          item-value="mmfId"
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="6" sm="4">
        <v-select
          v-model="statusSelect"
          :items="[
            { text: 'Εκκρεμεί', value: 'submittedToESMA' },
            { text: 'Απορρίφθηκε', value: 'returnedByESMA' },
            { text: 'Αποδεκτή', value: 'acceptedByESMA' },
          ]"
          value=""
          label="Κατάσταση"
          clearable
          hide-details
        ></v-select>
      </v-col>

      <v-col cols="6" sm="4">
        <v-checkbox
          v-model="lastOfCreditInstitute"
          label="Τελευταία έκθεση κάθε ΑΕΔΑΚ"
        ></v-checkbox>
      </v-col>
    </v-row>

    <div class="d-flex breadcrumb mb-4 mt-6">
      <v-btn @click="search" color="primary " class="ml-auto mr-3"
        >Αναζήτηση</v-btn
      >
      <v-btn
        @click="onExcelDownload"
        color="primary "
        :disabled="checkboxes.length == 0"
        >Εξαγωγή σε Excel</v-btn
      >
    </div>
    <div style="overflow: auto"></div>

    <v-data-table
      v-model="checkboxes"
      show-select
      item-key="reportId"
      :headers="headers"
      :items="submittedHcmcReports"
      :items-per-page="10"
      class="elevation-1 breadcrumb table"
      :loading="tableLoader"
      width="100%"
    >
      <template v-slot:[`item.uploadedToHCMCDate`]="{ item }">
        <div class="body-2">
          {{ new Date(item.uploadedToHCMCDate).toLocaleDateString("el") }}
          {{
            padTo2Digits(new Date(item.uploadedToHCMCDate).getHours()) +
              ":" +
              padTo2Digits(new Date(item.uploadedToHCMCDate).getMinutes())
          }}
        </div>
      </template>

      <template v-slot:[`item.submissionStatus`]="{ item }">
        <div class="body-2">
          <div v-if="item.submissionStatus == 'submittedToESMA'">
            <div class="d-flex align-center">Εκκρεμεί</div>
          </div>

          <div v-if="item.submissionStatus == 'returnedByESMA'">
            Απορρίφθηκε
          </div>

          <div v-if="item.submissionStatus == 'acceptedByESMA'">Αποδεκτή</div>
        </div>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex">
          <!-- <v-btn class="primary rounded body-2 mr-2" @click="onSave(item)">
            Λήψη XML
          </v-btn> -->

          <v-btn
            class="primary rounded body-2 mr-2"
            @click="onSingleDownloadPdf(item)"
          >
            Λήψη PDF
          </v-btn>

          <!-- <v-btn class="primary rounded body-2 mr-2" @click="onShow(item)">
            Προβολή XML
          </v-btn> -->

          <v-btn
            :disabled="item.submissionStatus == 'submittedToESMA'"
            class="primary rounded body-2 mr-2"
            @click="onSave(item)"
            >Λήψη Απάντησης</v-btn
          >
          <v-btn class="primary rounded body-2" @click="onResponse(item)"
            >Προβολή Απάντησης</v-btn
          >
        </div>
      </template>

      <template v-slot:[`item.submittedToESMADate`]="{ item }">
        <div class="body-2" v-if="item.submittedToESMADate != null">
          {{ new Date(item.submittedToESMADate).toLocaleDateString("el") }}
          {{
            padTo2Digits(new Date(item.submittedToESMADate).getHours()) +
              ":" +
              padTo2Digits(new Date(item.submittedToESMADate).getMinutes())
          }}
        </div>
      </template>

      <template v-slot:[`item.creditInstituteName`]="{ item }">
        <div class="body-2">
          {{
            item.creditInstituteName.length > 50
              ? item.creditInstituteName.substring(0, 30) + "..."
              : item.creditInstituteName
          }}
        </div>
      </template>

      <template v-slot:[`item.ESMARepliedOn`]="{ item }">
        <div class="body-2" v-if="item.ESMARepliedOn != null">
          {{ new Date(item.ESMARepliedOn).toLocaleDateString("el") }}
          {{
            padTo2Digits(new Date(item.ESMARepliedOn).getHours()) +
              ":" +
              padTo2Digits(new Date(item.ESMARepliedOn).getMinutes())
          }}
        </div>
      </template>
    </v-data-table>

    <v-dialog min-width="auto" v-model="dialog">
      <ShowReport v-if="dialog" />
    </v-dialog>

    <v-dialog min-width="auto" v-model="responseDialog">
      <ShowResponse v-if="responseDialog" />
    </v-dialog>
  </div>
</template>

<script>
import ShowReport from "../../components/Modals/ShowReport.vue";
import ShowResponse from "../../components/Modals/ShowResponse.vue";
import Breadcrumb from "../../components/Breadcrumb";
import { mapState, mapMutations, mapActions } from "vuex";
import axios from "axios";
export default {
  components: {
    Breadcrumb,
    ShowReport,
    ShowResponse,
  },

  async created() {
    try {
      this.year = new Date().getFullYear().toString();
      await this.getPeriods();
      await this.getCreditInstitutes();
      this.tableLoader = true;
      await this.getHcmcReports({
        creditInstituteId: this.creditInstitute?.creditInstituteId,
        reportPeriodId: this.period,
        reportStatus: this.statusSelect,
        fundId: this.fund,
        year: this.year,
        lastOfCreditInstitute: this.lastOfCreditInstitute,
      });
      this.tableLoader = false;

      this.setSubmittedHcmcReports();
      this.setSubmittedHcmcCreditInstitutes();
      this.setSubmittedPeriods();
    } catch {}
  },

  data() {
    return {
      tableLoader: false,
      headers: [
        {
          text: "Υποβολή στην ΕΚ",
          sortable: false,
          value: "uploadedToHCMCDate",
          width: "150px",
        },
        {
          text: "ΑΕΔΑΚ",
          sortable: false,
          value: "creditInstituteName",
          width: "300px",
        },

        {
          text: "Υποβάλων από ΑΕΔΑΚ",
          sortable: false,
          value: "uploadedToHCMCBy",
          width: "100px",
        },

        {
          text: "Υποβολή στην ESMA",
          sortable: false,
          value: "submittedToESMADate",
          width: "155px",
        },
        {
          text: "Υποβάλων από EK",
          sortable: false,
          value: "submittedToESMABy",
          width: "100px",
        },

        {
          text: "Απάντησης της ESMA",
          sortable: false,
          value: "ESMARepliedOn",
          width: "160px",
        },

        {
          text: "Απάντηση",
          sortable: false,
          value: "submissionStatus",
          width: "100px",
        },

        {
          text: "Επιλογές",
          sortable: false,
          value: "actions",
        },
      ],
      lastOfCreditInstitute: false,

      checkboxes: [],
      year: "2022",
      period: null,
      creditInstitute: null,
      fund: null,

      years: ["2020", "2021", "2022", "2023", "2024", "2025", "2026"],
      periods: [],
      creditInstitutes: [],

      periodsLoader: false,

      statusSelect: null,
      breadCrumbItems: [
        {
          text: "Αρχική",
          disabled: false,
          to: "hcmc",
        },
        {
          text: "Εκθέσεις που υποβλήθηκαν στην ESMA",
          disabled: true,
          to: "/hcmc/submitted/reports",
        },
      ],
    };
  },

  computed: {
    ...mapState({
      submittedHcmcReports: (state) => state.hcmcreports.submittedHcmcReports,
      submittedHcmcCreditInstitutes: (state) =>
        state.hcmcreports.submittedHcmcCreditInstitutes,
      submittedPeriods: (state) => state.hcmcreports.submittedPeriods,
      savedReport: (state) => state.reports.savedReport,
      currentHcmcReport: (state) => state.hcmcreports.currentHcmcReport,
    }),

    dialog: {
      get() {
        return this.$store.state.dialogs.showReportDialog;
      },
      set(value) {
        return this.updateShowReportDialog(value);
      },
    },

    responseDialog: {
      get() {
        return this.$store.state.dialogs.showResponseDialog;
      },
      set(value) {
        return this.updateShowResponseDialog(value);
      },
    },

    funds() {
      if (this.creditInstitute == null) return;
      return this.creditInstitute.funds;
    },
  },

  methods: {
    ...mapMutations([
      "setCurrentHcmcReport",
      "setSubmittedHcmcReports",
      "setSubmittedHcmcCreditInstitutes",
      "setSubmittedPeriods",
      "updateShowReportDialog",
      "updateShowResponseDialog",
      "setCurrentHcmcReportVersion",
    ]),
    ...mapActions(["getHcmcReports", "getSavedReport"]),

    padTo2Digits(num) {
      return String(num).padStart(2, "0");
    },

    async search() {
      try {
        this.tableLoader = true;

        await this.getHcmcReports({
          creditInstituteId: this.creditInstitute?.creditInstituteId,
          reportPeriodId: this.period,
          reportStatus: this.statusSelect,
          fundId: this.fund,
          year: this.year,
          lastOfCreditInstitute: this.lastOfCreditInstitute,
        });
        this.tableLoader = false;

        this.setSubmittedHcmcReports();
      } catch (e) {
        console.log(e);
      }
    },

    async getPeriods() {
      try {
        this.periodsLoader = true;

        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/System/GetPeriodsbyYear/${this.year}`
        );
        this.periods = res.data;
        this.periodsLoader = false;
      } catch (e) {
        this.periodsLoader = false;

        console.log(e);
      }
    },

    async getCreditInstitutes() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/System/GetCreditInstitutesAndFunds`
        );
        this.creditInstitutes = res.data;
      } catch (e) {
        console.log(e);
      }
    },

    async onSelectChange() {
      try {
        await this.getHcmcReports({
          creditInstituteId: this.bankSelect,
          reportPeriodId: this.periodSelect,
          reportStatus: this.statusSelect,
          yaer: this.year,
          lastOfCreditInstitute: this.lastOfCreditInstitute,
        });
        this.setSubmittedHcmcReports();
      } catch {}
    },

    async onSave(report) {
      try {
        await this.getSavedReport(report.lastUploadedVersionId);
        const filename = this.savedReport.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(
          new Blob([this.savedReport.data])
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch {}
    },

    onShow(item) {
      this.setCurrentHcmcReport(item);

      this.setCurrentHcmcReportVersion(item);
      this.updateShowReportDialog(true);
    },

    onResponse(item) {
      this.setCurrentHcmcReport(item);

      this.setCurrentHcmcReportVersion(item);
      this.updateShowResponseDialog(true);
    },

    async onExcelDownload() {
      try {
        const payload = this.checkboxes.map((el) => {
          return el.submittedVersionId;
        });
        const res = await axios.post(
          `${process.env.VUE_APP_BASE_URL}/report/ExportToExcel`,
          {
            reportIds: payload,
          },
          {
            responseType: "arraybuffer",
          }
        );

        const filename = res.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: "application/vnd.ms-excel" })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },

    async onSingleDownloadPdf(report) {
      try {
        const result = await axios({
          method: "get",
          url: `${process.env.VUE_APP_BASE_URL}/report/ExportSingleToPdf/${report.submittedVersionId}`,
          responseType: "arraybuffer",
        });

        const savedReport = result;

        const filename = savedReport.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim();

        const url = window.URL.createObjectURL(new Blob([savedReport.data]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch {}
    },
  },
};
</script>

<style scoped lang="scss">
.v-data-table {
  overflow-x: auto !important;
}
.breadcrumb {
  width: 100%;
  max-width: 100%;
}

@media only screen and (max-width: 960px) {
  .breadcrumb,
  .table {
    width: 100%;
  }
  // .select {
  //   width: auto !important;
  // }
}

@media only screen and (max-width: 600px) {
  .table {
    width: 350px;
  }

  .breadcrumb,
  .table {
    width: 350px;
    width: 100%;
  }
}
</style>
